export default __webpack_public_path__ + "static/media/mrb_large.aa8d7069.png";